import React from 'react'
import {Sidebar} from 'semantic-ui-react'
import styles from './styles.module.scss'

const SidebarComponent = ({visible, children}) => (
  <div className={styles.sidebarR}>
    <Sidebar
      animation="overlay"
      direction="right"
      visible={visible}
    >
      <Sidebar.Pusher className={styles.pusher}>
        {children}
      </Sidebar.Pusher>

    </Sidebar>
  </div>
)

export default SidebarComponent